/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespLayout_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_user" | "PdpSharedLayout_user">;
    } | null;
    readonly vipUserRelationships?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_vipUserRelationship">;
    } | null> | null;
    readonly itemRead: ReadonlyArray<{
        readonly displayInfo?: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_displayInfo">;
        } | null;
        readonly sellerItems?: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_sellerItems">;
        } | null;
        readonly similarLandingItems?: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_similarLandingItems">;
        } | null;
        readonly similarGridItems?: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_similarGridItems">;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_item">;
    } | null> | null;
    readonly relevantShipping: {
        readonly shipmentQuote: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipmentQuote">;
        } | null;
        readonly shipment: {
            readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipment">;
        } | null;
    } | null;
    readonly transactions: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_transactions">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_viewer" | "PdpSharedLayout_viewer">;
    readonly " $refType": "PdpRespLayout_viewer";
};
export type PdpRespLayout_viewer$data = PdpRespLayout_viewer;
export type PdpRespLayout_viewer$key = {
    readonly " $data"?: PdpRespLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
};
return {
  "kind": "Fragment",
  "name": "PdpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "relationshipUserIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemRead",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "Item",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_item",
              "args": null
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "isClient",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "displayInfo",
                  "storageKey": null,
                  "args": [
                    (v0/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "pdp"
                    }
                  ],
                  "concreteType": "ItemDisplayInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_displayInfo",
                      "args": null
                    }
                  ]
                }
              ]
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "fetchPdp",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": "sellerItems",
                  "name": "moreLikeThis",
                  "storageKey": "moreLikeThis(first:4,seller:\"INCLUDE\")",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 4
                    },
                    {
                      "kind": "Literal",
                      "name": "seller",
                      "value": "INCLUDE"
                    }
                  ],
                  "concreteType": "moreLikeThisConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_sellerItems",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "similarLandingItems",
                  "name": "moreLikeThis",
                  "storageKey": "moreLikeThis(first:12)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 12
                    }
                  ],
                  "concreteType": "moreLikeThisConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_similarLandingItems",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "similarGridItems",
                  "name": "moreLikeThis",
                  "storageKey": "moreLikeThis(first:8,seller:\"EXCLUDE\")",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 8
                    },
                    {
                      "kind": "Literal",
                      "name": "seller",
                      "value": "EXCLUDE"
                    }
                  ],
                  "concreteType": "moreLikeThisConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_similarGridItems",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShipping",
      "storageKey": null,
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuote",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipmentQuote",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipment",
          "storageKey": null,
          "args": null,
          "concreteType": "Shipment",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipment",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "transactions",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemIds"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespContainer_transactions",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "vipUserRelationships",
          "name": "userRelationships",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "relationshipUserIds"
            }
          ],
          "concreteType": "UserRelationship",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_vipUserRelationship",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'cc726d02d308d3bbdeb4da426c1c8369';
export default node;
